export default __webpack_public_path__ + "static/comp-4dfa7e413a3d59b5efc0373bec322bcb.svg";